/* Thread Mug – "Added to your cart" (2026-10-02, unified side cart).
   One panel, two modes: after any Add to Cart we open the theme's own side cart drawer
   (#t4s-mini_cart, sections/mini_cart.liquid) with freshly rendered contents
   (Section Rendering API: /?sections=mini_cart) and put on top of it a green
   "Added to your cart" strip + "Pairs well with" (complementary recommendations
   for the just-added product, excluding products already in the cart).
   Opened from the cart icon, the same drawer shows without the strip.
   If the drawer is missing or does not open, the previous standalone panel below
   (legacyShow) is used instead, so it is never a dead end.
   Callers: assets/quick-view-threadmug.js and assets/tm-pdp-atc.js:
     window.TMAddedPanel.show(lineItem, { title, productId, fallback })
   Config comes from the hidden [data-tm-added-config] element in snippets/quick-view-threadmug.liquid. */
(function () {
  'use strict';
  if (window.TMAddedPanel) return;

  var cfgEl = document.querySelector('[data-tm-added-config]');
  var moneyFormat = (cfgEl && cfgEl.getAttribute('data-money-format')) || '${{amount}}';
  var cartUrl = (cfgEl && cfgEl.getAttribute('data-cart-url')) || '/cart';
  var rootUrl = (cfgEl && cfgEl.getAttribute('data-root-url')) || '/';
  var recsUrl = (cfgEl && cfgEl.getAttribute('data-recommendations-url')) || '/recommendations/products';

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
    } catch (e) {}
    var amount = (Number(cents) / 100).toFixed(2);
    var noDec = String(Math.round(Number(cents) / 100));
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (/\{\{\s*amount/.test(moneyFormat)) {
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, withComma);
    }
    return '$' + withComma;
  }

  function bumpCartIcons() {
    document.querySelectorAll('.t4s-site-nav__cart, .t4s-toolbart-cart').forEach(function (el) {
      el.classList.remove('tm-cart-bump');
      void el.offsetWidth;
      el.classList.add('tm-cart-bump');
      setTimeout(function () {
        el.classList.remove('tm-cart-bump');
      }, 1300);
    });
  }

  function updateHeaderCart(cart) {
    if (!cart) return;
    var count = Number(cart.item_count) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('[data-cart-tt-price]').forEach(function (el) {
      el.textContent = money(cart.total_price);
    });
    var html = document.documentElement;
    html.className = html.className.replace(/\bt4s-cart-count-\d+\b/, 't4s-cart-count-' + count);
    var mini = document.getElementById('t4s-mini_cart');
    if (mini) mini.setAttribute('data-ccount', count);
    bumpCartIcons();
  }

  var panel = null;
  var lastFocus = null;

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cart) return null;
        updateHeaderCart(cart);
        if (panel) {
          var sub = panel.querySelector('[data-tm-added-subtotal]');
          var cnt = panel.querySelector('[data-tm-added-count]');
          if (sub) sub.textContent = money(cart.total_price);
          if (cnt) cnt.textContent = 'Cart subtotal (' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ')';
        }
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        } catch (e) {}
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function close() {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tm-added-open');
    setTimeout(function () {
      if (panel && !panel.classList.contains('is-open')) panel.hidden = true;
    }, 300);
    setTimeout(bumpCartIcons, 320);
    if (lastFocus && lastFocus.focus) {
      try {
        lastFocus.focus({ preventScroll: true });
      } catch (e) {}
    }
  }

  function ensurePanel() {
    if (panel) return panel;
    /* The product page builds its own panel with the same classes; reuse nothing from it so the two never clash. */
    panel = document.createElement('div');
    panel.className = 'tm-added tm-added--qv';
    panel.hidden = true;
    panel.setAttribute('aria-hidden', 'true');
    panel.innerHTML =
      '<div class="tm-added__overlay" data-tm-added-close></div>' +
      '<div class="tm-added__panel" role="dialog" aria-modal="true" aria-labelledby="tm-added-qv-title" tabindex="-1">' +
      '<span class="tm-added__handle" aria-hidden="true"></span>' +
      '<div class="tm-added__head">' +
      '<p class="tm-added__title" id="tm-added-qv-title">' +
      '<span class="tm-added__title-icon" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>' +
      'Added to your cart</p>' +
      '<button type="button" class="tm-added__close" data-tm-added-close aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="tm-added__body" data-tm-added-body></div>' +
      '<div class="tm-added__foot">' +
      '<p class="tm-added__subtotal"><span data-tm-added-count>Cart subtotal</span><strong data-tm-added-subtotal></strong></p>' +
      '<div class="tm-added__btns">' +
      '<a class="tm-added__btn tm-added__btn--solid" href="' + esc(rootUrl.replace(/\/$/, '') + '/checkout') + '">Checkout</a>' +
      '<a class="tm-added__btn tm-added__btn--ghost" href="' + esc(cartUrl) + '">View cart</a>' +
      '</div>' +
      '<button type="button" class="tm-added__keep" data-tm-added-close>Keep shopping</button>' +
      '</div>' +
      '</div>';
    document.body.appendChild(panel);
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-tm-added-close]')) {
        close();
        return;
      }
      var quick = e.target.closest('[data-tm-added-quick]');
      if (quick) {
        e.preventDefault();
        if (quick.disabled) return;
        quick.disabled = true;
        quick.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: Number(quick.getAttribute('data-tm-added-quick')), quantity: 1 }] }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return refreshCart();
          })
          .then(function () {
            quick.textContent = '✓ Added';
          })
          .catch(function () {
            quick.disabled = false;
            quick.textContent = 'Try again';
          });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) close();
    });
    return panel;
  }

  function lineHtml(line, title) {
    if (!line || !line.title) return '';
    var props = '';
    var p = line.properties || {};
    Object.keys(p).forEach(function (k) {
      var v = p[k];
      if (!k || k.charAt(0) === '_' || v == null || String(v).trim() === '') return;
      if (String(v).indexOf('/uploads/') !== -1 || /^https?:\/\//.test(String(v))) v = 'Uploaded file';
      props += '<li><span>' + esc(k) + ':</span> ' + esc(v) + '</li>';
    });
    var variant = line.variant_title && !/default title/i.test(line.variant_title) ? line.variant_title : '';
    var img = line.image ? String(line.image) : '';
    if (img) img = img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=300';
    return (
      '<div class="tm-added__item">' +
      (img ? '<img class="tm-added__item-img" src="' + esc(img) + '" alt="" width="112" height="112">' : '') +
      '<div class="tm-added__item-info">' +
      '<p class="tm-added__item-title">' + esc(title || line.product_title || line.title) + '</p>' +
      (variant ? '<p class="tm-added__item-variant">' + esc(variant) + '</p>' : '') +
      (props ? '<ul class="tm-added__item-props">' + props + '</ul>' : '') +
      '<p class="tm-added__item-price">' +
      (line.quantity > 1 ? esc(line.quantity) + ' × ' : '') +
      esc(money(line.final_price != null ? line.final_price : line.price)) +
      '</p>' +
      '</div>' +
      '</div>'
    );
  }

  /* "Pairs well with this": the same Shopify complementary-products section the product page uses
     (sections/tm-complementary-recommendations.liquid), so the picks and short names match. */
  function pairsHtmlFromCards(cards) {
    var html = '';
    var shown = 0;
    for (var i = 0; i < cards.length && shown < 3; i++) {
      var c = cards[i];
      var url = c.getAttribute('data-product-url') || '#';
      var title = c.getAttribute('data-product-title') || '';
      var price = c.getAttribute('data-price');
      var img = c.querySelector('img');
      var available = c.getAttribute('data-available') === 'true';
      var personalize =
        c.getAttribute('data-requires-personalization') === 'true' ||
        c.getAttribute('data-name-field-required') === 'true';
      var vid = c.getAttribute('data-variant-id');
      var quickAddable = !!c.querySelector('[data-tm-card-checkbox]');
      var action = personalize
        ? '<a class="tm-added__pair-btn" href="' + esc(url) + '">Personalize</a>'
        : available && vid && quickAddable
        ? '<button type="button" class="tm-added__pair-btn" data-tm-added-quick="' + esc(vid) + '">+ Add</button>'
        : '<a class="tm-added__pair-btn" href="' + esc(url) + '">View</a>';
      html +=
        '<li class="tm-added__pair">' +
        '<a class="tm-added__pair-media" href="' + esc(url) + '">' +
        (img ? '<img src="' + esc(img.getAttribute('src') || '') + '" alt="" loading="lazy" width="56" height="56">' : '') +
        '</a>' +
        '<a class="tm-added__pair-info" href="' + esc(url) + '">' +
        '<span class="tm-added__pair-title">' + esc(title) + '</span>' +
        (price ? '<span class="tm-added__pair-price">' + esc(money(price)) + '</span>' : '') +
        '</a>' +
        action +
        '</li>';
      shown++;
    }
    if (!html) return '';
    return (
      '<div class="tm-added__pairs">' +
      '<p class="tm-added__pairs-heading">Pairs well with this</p>' +
      '<ul class="tm-added__pairs-list">' + html + '</ul>' +
      '</div>'
    );
  }

  function loadPairs(productId) {
    if (!productId) return Promise.resolve('');
    var url =
      recsUrl +
      '?section_id=tm-complementary-recommendations&product_id=' +
      encodeURIComponent(productId) +
      '&limit=6&intent=complementary';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.text() : '';
      })
      .then(function (text) {
        if (!text || text.indexOf('data-tm-recommendation-card') === -1) return '';
        var doc = new DOMParser().parseFromString(text, 'text/html');
        return pairsHtmlFromCards(doc.querySelectorAll('[data-tm-recommendation-card]'));
      })
      .catch(function () {
        return '';
      });
  }

  function open() {
    if (panel.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    void panel.offsetWidth;
    panel.classList.add('is-open');
    document.documentElement.classList.add('tm-added-open');
    var dialog = panel.querySelector('.tm-added__panel');
    try {
      dialog.focus({ preventScroll: true });
    } catch (e) {}
  }

  var openTimer = null;
  function legacyShow(line, opts) {
    opts = opts || {};
    ensurePanel();
    var body = panel.querySelector('[data-tm-added-body]');
    body.innerHTML = lineHtml(line, opts.title) + '<div data-tm-added-pairs></div>';
    var sub = panel.querySelector('[data-tm-added-subtotal]');
    if (sub) sub.textContent = '';
    loadPairs(opts.productId || (line && line.product_id)).then(function (html) {
      var slot = panel.querySelector('[data-tm-added-pairs]');
      if (slot && html) slot.innerHTML = html;
    });
    /* Same timing as the product page: cart icon bounces first, then the panel slides in. */
    clearTimeout(openTimer);
    var started = Date.now();
    var delay = reduceMotion ? 0 : 500;
    var opened = false;
    var openOnce = function () {
      if (opened) return;
      opened = true;
      clearTimeout(openTimer);
      open();
    };
    if (!delay) openOnce();
    openTimer = setTimeout(openOnce, delay ? 1400 : 0);
    refreshCart().then(function () {
      if (opened) return;
      var wait = Math.max(0, delay - (Date.now() - started));
      clearTimeout(openTimer);
      openTimer = setTimeout(openOnce, wait);
    });
  }

  /* =====================================================================
     Unified side cart — "just added" mode inside the theme drawer
     ===================================================================== */
  var DRAWER_ID = 't4s-mini_cart';
  var SECTION_ID = 'mini_cart';
  var CHECK_SVG =
    '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  var addedActive = false; /* drawer is in "just added" mode */
  var addedOpened = false; /* ...and has been seen open (so a later close ends the mode) */
  var stripHtml = ''; /* green strip for the just-added item */
  var pairsList = []; /* [{pid, html}] "Pairs well with" rows */
  var showToken = 0;
  var openedFor = 0;
  var selfMutating = false;
  var contentObserver = null;
  var attrObserver = null;
  var syncTimer = null;
  var exitTimer = null;

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  function isOpen(d) {
    return !!d && d.getAttribute('aria-hidden') === 'false';
  }

  /* Header cart icon (desktop) or bottom toolbar cart icon (mobile): whichever is visible. */
  function pickTrigger() {
    var list = document.querySelectorAll('[data-drawer-options*="' + DRAWER_ID + '"]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getClientRects().length) return list[i];
    }
    return list[0] || null;
  }

  function withSelf(fn) {
    selfMutating = true;
    try {
      fn();
    } finally {
      if (contentObserver) contentObserver.takeRecords();
      selfMutating = false;
    }
  }

  function sectionsUrl() {
    return rootUrl.replace(/\/?$/, '/') + '?sections=' + SECTION_ID;
  }

  /* Section Rendering API -> inner HTML of the mini_cart section (null on any problem). */
  function fetchSection() {
    return fetch(sectionsUrl(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        var html = data && data[SECTION_ID];
        if (!html || typeof html !== 'string') return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.getElementById('shopify-section-' + SECTION_ID) || doc.body;
        if (!wrap || !wrap.querySelector('.t4s-drawer__header')) return null;
        return wrap.innerHTML;
      })
      .catch(function () {
        return null;
      });
  }

  function addedHtml() {
    if (!stripHtml) return '';
    var pairs = '';
    if (pairsList.length) {
      pairs =
        '<div class="tm-mc-pairs" data-tm-mc-pairs>' +
        '<p class="tm-mc-pairs__heading">Pairs well with</p>' +
        '<ul class="tm-mc-pairs__list">' +
        pairsList
          .map(function (p) {
            return p.html;
          })
          .join('') +
        '</ul></div>';
    }
    return stripHtml + pairs;
  }

  /* Put (or keep) the strip + pairs at the top of the drawer while in "just added" mode. */
  function injectAdded(d, force) {
    d = d || getDrawer();
    if (!d) return;
    withSelf(function () {
      if (addedActive) d.classList.add('tm-mc--added');
      else d.classList.remove('tm-mc--added');
      var slot = d.querySelector('[data-tm-mc-added]');
      if (!addedActive) {
        if (slot && slot.firstChild) slot.innerHTML = '';
        return;
      }
      if (!slot) {
        var scroll = d.querySelector('[data-t4s-scroll-me]') || d.querySelector('.t4s-drawer__scroll');
        if (!scroll) return;
        slot = document.createElement('div');
        slot.className = 'tm-mc-added';
        slot.setAttribute('data-tm-mc-added', '');
        scroll.insertBefore(slot, scroll.firstChild);
      }
      if (force || !slot.querySelector('.tm-mc-added__strip')) slot.innerHTML = addedHtml();
    });
  }

  function afterRender(d) {
    try {
      if (window.TMDelivery && typeof window.TMDelivery.refresh === 'function') window.TMDelivery.refresh(d);
    } catch (e) {}
    injectAdded(d, true);
  }

  function applySection(inner) {
    var d = getDrawer();
    if (!d || !inner) return false;
    withSelf(function () {
      /* Same container the theme fills: a .shopify-section wrapper if the theme keeps one, else the drawer itself. */
      var host = null;
      for (var i = 0; i < d.children.length; i++) {
        if (d.children[i].classList.contains('shopify-section')) host = d.children[i];
      }
      (host || d).innerHTML = inner;
    });
    afterRender(d);
    return true;
  }

  /* Keep heading / discount row / totals right if the theme updates the drawer only partly
     (e.g. after a quantity change): re-render the section and copy the [data-tm-mc-sync] parts. */
  function syncParts() {
    var d = getDrawer();
    if (!d || !isOpen(d) || !d.querySelector('[data-tm-mc-sync]')) return;
    fetchSection().then(function (inner) {
      if (!inner) return;
      var doc = new DOMParser().parseFromString('<div>' + inner + '</div>', 'text/html');
      withSelf(function () {
        d.querySelectorAll('[data-tm-mc-sync]').forEach(function (el) {
          var fresh = doc.querySelector('[data-tm-mc-sync="' + el.getAttribute('data-tm-mc-sync') + '"]');
          if (fresh && fresh.innerHTML !== el.innerHTML) el.innerHTML = fresh.innerHTML;
        });
      });
    });
  }

  function exitAdded() {
    addedActive = false;
    addedOpened = false;
    stripHtml = '';
    pairsList = [];
    injectAdded(getDrawer());
  }

  function ensureObservers() {
    var d = getDrawer();
    if (!d || !window.MutationObserver) return;
    if (!contentObserver) {
      contentObserver = new MutationObserver(function (records) {
        if (selfMutating) return;
        var dd = getDrawer();
        if (!dd) return;
        var full = false;
        var partial = false;
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          var t = r.target && r.target.nodeType === 1 ? r.target : r.target && r.target.parentElement;
          if (!t || (t.closest && t.closest('[data-tm-mc-added]'))) continue;
          if (t === dd || (t.parentElement === dd && t.classList.contains('shopify-section'))) full = true;
          else if (t.closest && t.closest('[data-cart-items]')) partial = true;
        }
        if (addedActive) injectAdded(dd);
        if (partial && !full) {
          clearTimeout(syncTimer);
          syncTimer = setTimeout(syncParts, 350);
        }
      });
      contentObserver.observe(d, { childList: true, subtree: true, characterData: true });
    }
    if (!attrObserver) {
      attrObserver = new MutationObserver(function () {
        var dd = getDrawer();
        if (!addedActive) return;
        if (isOpen(dd)) {
          addedOpened = true;
          clearTimeout(exitTimer);
          return;
        }
        if (addedOpened) {
          /* closed: leave the strip in place for the slide-out, then return to plain "view cart" mode */
          clearTimeout(exitTimer);
          exitTimer = setTimeout(function () {
            if (!isOpen(getDrawer())) exitAdded();
          }, 600);
        }
      });
      attrObserver.observe(d, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }

  function drawerStripHtml(line, title) {
    if (line && !line.title && line.items && line.items.length) line = line.items[0];
    var item = '';
    if (line && line.title) {
      var props = '';
      var p = line.properties || {};
      Object.keys(p).forEach(function (k) {
        var v = p[k];
        if (!k || k.charAt(0) === '_' || v == null || String(v).trim() === '') return;
        if (String(v).indexOf('/uploads/') !== -1 || /^https?:\/\//.test(String(v))) v = 'Uploaded file';
        props += '<li>' + esc(k) + ': ' + esc(v) + '</li>';
      });
      var variant = line.variant_title && !/default title/i.test(line.variant_title) ? line.variant_title : '';
      var img = line.image ? String(line.image) : '';
      if (img) img = img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=160';
      var qty = Number(line.quantity) || 1;
      item =
        '<div class="tm-mc-added__item">' +
        (img ? '<img class="tm-mc-added__img" src="' + esc(img) + '" alt="" width="56" height="56">' : '') +
        '<div class="tm-mc-added__info">' +
        '<p class="tm-mc-added__name">' + esc(title || line.product_title || line.title) + '</p>' +
        (variant ? '<p class="tm-mc-added__variant">' + esc(variant) + '</p>' : '') +
        (props ? '<ul class="tm-mc-added__props">' + props + '</ul>' : '') +
        '<p class="tm-mc-added__price">' + esc(qty) + ' × ' +
        esc(money(line.final_price != null ? line.final_price : line.price)) +
        '</p>' +
        '</div>' +
        '</div>';
    }
    return (
      '<div class="tm-mc-added__strip" role="status">' +
      '<p class="tm-mc-added__title"><span class="tm-mc-added__icon" aria-hidden="true">' + CHECK_SVG + '</span>Added to your cart</p>' +
      item +
      '</div>'
    );
  }

  /* Same card rules as the existing panel: personalised / name-field-required -> "Personalize",
     one-click only when the card offers its quick-add checkbox, otherwise "View". */
  function drawerPairRow(c) {
    var url = c.getAttribute('data-product-url') || '#';
    var title = c.getAttribute('data-product-title') || '';
    var price = c.getAttribute('data-price');
    var img = c.querySelector('img');
    var available = c.getAttribute('data-available') === 'true';
    var personalize =
      c.getAttribute('data-requires-personalization') === 'true' ||
      c.getAttribute('data-name-field-required') === 'true';
    var vid = c.getAttribute('data-variant-id');
    var pid = c.getAttribute('data-product-id') || '';
    var quickAddable = !!c.querySelector('[data-tm-card-checkbox]');
    var action = personalize
      ? '<a class="tm-mc-pair__btn" href="' + esc(url) + '">Personalize</a>'
      : available && vid && quickAddable
      ? '<button type="button" class="tm-mc-pair__btn" data-tm-mc-quick="' + esc(vid) + '" data-pid="' + esc(pid) + '">+ Add</button>'
      : '<a class="tm-mc-pair__btn" href="' + esc(url) + '">View</a>';
    return {
      pid: String(pid),
      html:
        '<li class="tm-mc-pair" data-pid="' + esc(pid) + '">' +
        '<a class="tm-mc-pair__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + esc(img.getAttribute('src') || '') + '" alt="" loading="lazy" width="48" height="48">' : '') +
        '</a>' +
        '<a class="tm-mc-pair__info" href="' + esc(url) + '">' +
        '<span class="tm-mc-pair__title">' + esc(title) + '</span>' +
        (price ? '<span class="tm-mc-pair__price">' + esc(money(price)) + '</span>' : '') +
        '</a>' +
        action +
        '</li>',
    };
  }

  function loadDrawerPairs(productId, cart) {
    if (!productId) return Promise.resolve([]);
    var inCart = {};
    ((cart && cart.items) || []).forEach(function (it) {
      inCart[String(it.product_id)] = true;
    });
    inCart[String(productId)] = true;
    var url =
      recsUrl +
      '?section_id=tm-complementary-recommendations&product_id=' +
      encodeURIComponent(productId) +
      '&limit=10&intent=complementary';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.text() : '';
      })
      .then(function (text) {
        if (!text || text.indexOf('data-tm-recommendation-card') === -1) return [];
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var cards = doc.querySelectorAll('[data-tm-recommendation-card]');
        var out = [];
        for (var i = 0; i < cards.length && out.length < 3; i++) {
          var pid = cards[i].getAttribute('data-product-id');
          if (pid && inCart[String(pid)]) continue;
          out.push(drawerPairRow(cards[i]));
        }
        return out;
      })
      .catch(function () {
        return [];
      });
  }

  function scrollDrawerTop(d) {
    var sc = d && (d.querySelector('[data-t4s-scroll-me]') || d.querySelector('.t4s-drawer__scroll'));
    if (sc) sc.scrollTop = 0;
  }

  function openDrawer(token, fb) {
    if (token !== showToken || openedFor === token) return;
    openedFor = token;
    var d = getDrawer();
    if (isOpen(d)) {
      addedOpened = true;
      injectAdded(d);
      scrollDrawerTop(d);
      return;
    }
    var trig = pickTrigger();
    if (!trig) {
      exitAdded();
      fb();
      return;
    }
    trig.click();
    var t0 = Date.now();
    (function poll() {
      if (token !== showToken) return;
      var dd = getDrawer();
      if (isOpen(dd)) {
        addedOpened = true;
        injectAdded(dd);
        scrollDrawerTop(dd);
        return;
      }
      if (Date.now() - t0 > 3000) {
        /* the drawer did not open: previous standalone panel instead */
        exitAdded();
        fb();
        return;
      }
      setTimeout(poll, 100);
    })();
  }

  function drawerShow(line, opts, fb) {
    ensureObservers();
    var token = ++showToken;
    var productId = opts.productId || (line && (line.product_id || (line.items && line.items[0] && line.items[0].product_id))) || null;
    clearTimeout(exitTimer);
    addedActive = true;
    addedOpened = isOpen(getDrawer());
    stripHtml = drawerStripHtml(line, opts.title);
    pairsList = [];
    var started = Date.now();
    var minDelay = reduceMotion ? 0 : 500; /* let the cart icon bounce first */
    var cartP = refreshCart();
    var secP = fetchSection();
    var go = function () {
      var wait = Math.max(0, minDelay - (Date.now() - started));
      setTimeout(function () {
        openDrawer(token, fb);
      }, wait);
    };
    /* never wait more than 2.5s for the network before opening */
    var safety = setTimeout(function () {
      if (token === showToken) {
        injectAdded(getDrawer(), true);
        openDrawer(token, fb);
      }
    }, 2500);
    Promise.all([cartP, secP]).then(function (r) {
      if (token !== showToken) return;
      clearTimeout(safety);
      var cart = r[0];
      if (!applySection(r[1])) injectAdded(getDrawer(), true);
      go();
      loadDrawerPairs(productId, cart).then(function (rows) {
        if (token !== showToken || !addedActive || !rows.length) return;
        pairsList = rows;
        injectAdded(getDrawer(), true);
      });
    });
  }

  /* One-click add from "Pairs well with" (drawer). */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var keep = t.closest('#' + DRAWER_ID + ' [data-tm-mc-keep]');
    if (keep) {
      e.preventDefault();
      var d = getDrawer();
      var closeBtn = d && d.querySelector('[data-drawer-close]');
      if (closeBtn) closeBtn.click();
      return;
    }
    var quick = t.closest('#' + DRAWER_ID + ' [data-tm-mc-quick]');
    if (!quick) return;
    e.preventDefault();
    if (quick.disabled) return;
    quick.disabled = true;
    quick.textContent = 'Adding…';
    var pid = quick.getAttribute('data-pid');
    fetch(rootUrl.replace(/\/?$/, '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(quick.getAttribute('data-tm-mc-quick')), quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        quick.textContent = '✓ Added';
        /* it is in the cart now: drop it from "Pairs well with", re-render the lines + totals */
        pairsList = pairsList.filter(function (p) {
          return p.pid !== String(pid);
        });
        return Promise.all([refreshCart(), fetchSection()]);
      })
      .then(function (r) {
        if (!applySection(r && r[1])) injectAdded(getDrawer(), true);
      })
      .catch(function () {
        quick.disabled = false;
        quick.textContent = 'Try again';
      });
  });

  function show(line, opts) {
    opts = opts || {};
    var fb = function () {
      if (typeof opts.fallback === 'function') {
        try {
          opts.fallback();
          return;
        } catch (e) {}
      }
      legacyShow(line, opts);
    };
    var d = getDrawer();
    if (!d || !pickTrigger() || !window.fetch || !window.DOMParser || !window.Promise) {
      fb();
      return;
    }
    try {
      drawerShow(line, opts, fb);
    } catch (e) {
      exitAdded();
      fb();
    }
  }

  var TMDrawer = { show: drawerShow, exit: exitAdded, sync: syncParts };
  /* Observe from page load so "view cart" mode also gets the heading/total sync. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureObservers);
  else ensureObservers();

  window.TMAddedPanel = { show: show, close: close, refreshCart: refreshCart, legacyShow: legacyShow, drawer: TMDrawer };
})();